import moment from 'moment';
import React, {useEffect, useState} from "react";
import jwt from "jsonwebtoken";
import HTMLReactParser from "html-react-parser";
import FunctionsData from "../Functions/FunctionsData";

let linkTerms = 'https://desexing.spca.nz/images/assets/1586/1/Voucher%20Terms%20and%20Conditions.pdf';
const publicUrl = 'https://pub-796e62f6a8694829b74ff337800a1dcd.r2.dev';

export default function PrintTemplate({decoded,currentVetArr,email, sponsorId,sponsorName,sponsorProgram,sponsorCost,sponsorEmailText,sponsorLogo,jwtKey,cid, voucher}) {

	//console.log(props);
	const urlJwt =  {
		name:currentVetArr.business_name,
		order_id:decoded.order_id,
		email:decoded.email,
		user: decoded.user,
		vet_id:currentVetArr.id
	};

	const name = decoded.user || 'The name';
	const vet = currentVetArr || [];
	//et dte0 = (decoded.expiry) ? new Date(decoded.expiry) :  new Date().setDate(new Date().getDate() + 4 * 7);
	let dte0 = (decoded.expiry) ? moment(decoded.expiry) :  moment().add(4 * 7, 'days');
	let loc = removeLastPathCharacter(window.location.host);
	let link = '/print/?cid='+jwt.sign({...urlJwt,vouchers:voucher}, jwtKey);
	let url = 'https://'+loc + link;
	const len  = voucher.length;

	try {
		if(!(decoded.expiry)) {
			dte0 = moment(decoded.vouchers[0][2]);
		}
	}catch(e) {
		dte0 = moment().add(4 * 7, 'days')
	}

	let dte = dte0.format('DD/MM/YYYY');
	const [order,setOrder] = useState(
		(email === true) ?
			{
				sponsor_id:sponsorId,
				sponsor_name:sponsorName,
				sponsor_program:sponsorProgram,
				sponsor_applicant_cost:sponsorCost,
				sponsor_email_text:sponsorEmailText,
				sponsor_logo:sponsorLogo,
				has_sponsor:(sponsorId > 0) ? 1 : 0
			}
			:
			null
	);

	async function fn(oID) {
		const path = '/api/orders-print/template/'+oID;
		return await fetch(FunctionsData.getApiUrl(path), {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': cid
			}
		})
			.then((res) => res.json())
			.then((d) => {
				console.log(d)
				setOrder (d.data);
			});
	}

	useEffect(() => {
		if(email === false) {
			fn(decoded.order_id).then(r => console.log(url = window.location.href));
		}
	}, [decoded, email])

	function removeLastPathCharacter(str) {
		if (str.slice(-1) == '/') {
			return str.slice(0, -1);
		}
		return str;
	}

	// if(email === false) {
	// 	url = window.location.href;
	// }

	if(!order) return <>Loading...</>;
	return (
		<div style={{fontFamily:'"Trebuchet MS", Helvetica, sans-serif',width: '100%', display:'flex', justifyContent:'center'}}>
			<div style={{width: '600px'}}>

				<div>
					<img src={`${publicUrl}/header.png`} style={{width:'100%',marginBottom: '20px'}} />
				</div>

				<h3 style={{marginBottom: '20px'}}>Hi {name},</h3>
				<p style={{marginBottom: '20px'}}>Thank you for registering for our Snip ‘n’ Chip campaign.</p>

				{
					(order && order.has_sponsor > 0) ?
						<div style={{border:'none', margin:'20px 0'}}>
							<hr  style={{marginBottom: 20}} />
							<p>{HTMLReactParser(String(order.sponsor_email_text)) ?? 'You won\'t need to pay anything at the veterinary clinic at the time of your appointment.'}</p>
							<hr style={{marginTop: 20}} />
						</div>
						: undefined
				}

				<div style={{width: 'calc(100% - 40px)', border:'none', background: 'white', color: '#1378C6', marginBottom: '20px'}}>
					<h3 style={{marginBottom: '10px',}}>Here {(len > 1) ? "are" : "is"} your voucher code{(len > 1) ? "s" : ""}.</h3>
					{voucher.map((v,idx) => {

						const k = Date.now()+Math.floor(Math.random() * 100000);


						if(email === true) return (
							<div key={k} style={{width: '100%', textAlign: 'center', padding:'10px' +
									' 20px',
								marginBottom: '10px',
								border:'1px solid #1378C6',
								background:'#eff8ff'
							}}>
								<p key={k}>Voucher for {v[0]}: # {v[1]}</p>
								<img src={`${publicUrl}/voucher/`+v[1]+".png"} />
							</div>
						)

						return (
							<div key={k} style={{width: '100%', textAlign: 'center', padding:'10px' +
									' 20px',
								marginBottom: '10px',
								border:'1px solid #1378C6',
								background:'#eff8ff'
							}}>
								<p key={k}>Voucher for {v[0]}: # {v[1]}</p>
								<img src={publicUrl + "/voucher/"+v[1]+".png"} />
							</div>
						)
					})}
				</div>

				<p style={{marginBottom: '20px'}}>To arrange your Snip 'n' Chip appointment(s), please contact the veterinary clinic you selected as part of the registration process:</p>

				<div style={{color:'#1378C6', fontWeight:'bold',marginBottom: '20px'}}>
					{vet.business_name}<br />
					{vet.formatted_address} <br />
					{(String(vet.phone) !== '' && String(vet.phone) !== 'null' && vet.phone !== '0') ? <>Phone: {vet.phone}<br /></> : ""}
					{(String(vet.email) !== '' && String(vet.email) !== 'null') ? <>Email: {vet.email}<br /></> : ""}
					{(vet.supplier_website !== '' && String(vet.supplier_website) !== 'null') ? <>{vet.supplier_website} </> : ""}<br />
					{(vet.supplier_terms !== '') ? <>T&Cs: {vet.supplier_terms}</> : undefined}
				</div>

				<p style={{marginBottom: '20px'}}>All vouchers in this campaign are valid until {dte}, please make sure your appointment is before this date.</p>
				<p style={{marginBottom: '20px'}}>Please be aware that due to the number of Snip ‘n’ Chip registrations the veterinary clinics receive, there may be a wait of up to 6 weeks before your animal’s surgery date.</p>

				 {/*<pre>{JSON.stringify(order, null,4)}</pre>*/}
				{
					(order && order.has_sponsor > 0) ?
						undefined
						:
						<>
							<p style={{marginBottom: '20px'}}>You will need to pay $30 per animal to the veterinary clinic at the time of your appointment.</p>
						</>
				}

				<p style={{marginBottom: '20px'}}>Our desexing vouchers for this campaign include microchipping and registration on the <a href={"https://www.animalregister.co.nz/"} target={"_blank"} rel={"noreferrer"}>NZCAR database</a>. This email address will be used as the registered owner of these animals, unless updated by the vet clinic. You will receive an email from NZCAR once the microchip has been registered. If you have questions or concerns regarding microchipping, please speak to the vet clinic at the time of booking.</p>
				<p style={{marginBottom: '20px', fontWeight:'bold'}}>Please advise the vet clinic of your Snip 'n' Chip voucher  when you book, and make sure you have the voucher code handy for validation.</p>
				<p style={{marginBottom: '20px'}}>Any changes to your appointment, or cancellations, must be made through the veterinary clinic.</p>
				<p style={{marginBottom: '20px'}}>You can use this <a href={url}>link</a> to print your voucher at any time.</p>

				<hr style={{marginBottom: '20px'}} />

				<p style={{marginBottom: '20px', fontWeight:'bold'}}>Your Snip ‘n’ Chip voucher does not include any additional services, surgeries or products provided by the veterinary clinic e.g. flea/worm products, vaccinations, dental work.</p>
				<p style={{marginBottom: '20px', fontWeight:'bold'}}>For more information on desexing and answers to common questions, please see <a href={"https://www.spca.nz/advice-and-welfare/article/desexing-your-companion-animals-saves-lives?cat=&subcat="} target={"_blank"}>our website</a>.</p>
				<p style={{marginBottom: '20px', fontWeight:'bold'}}>If you have any questions, please reply to this email.</p>

				<hr style={{marginBottom: '20px'}} />

				<p style={{marginBottom: '20px'}}>Thank you for being part of the solution!</p>
				<p style={{marginBottom: '20px'}}>Your team at SPCA&nbsp;{(order && order.has_sponsor > 0) ? <>and {order.sponsor_name ?? 'our sponsor'}</> : ""}</p>

				{
					(order && order.has_sponsor > 0) ?
						<div style={{border:'none', margin:'20px 0', textAlign:"center"}}>
							<img src={`${publicUrl}/snipnchip_logo.png`} width={220} height={80} style={{width:200, height:'80px !important'}} />
							<img src={order.sponsor_logo} width={200} height={80} style={{width:200, height:'80px !important'}} />
						</div>
						:
						<div style={{border:'none', margin:'20px 0'}}>
							<img src={`${publicUrl}/snipnchip_logo.png`} width={260} height={100} />
						</div>
				}

				<div style={{width: 'calc(100% - 40px)', background: '#1378C6', color: 'white', padding: 20}}>
					<p style={{marginBottom: '20px'}}>SPCA is a registered charitable organisation under the Charities Act 2005. Our Charities
					Commission registration number is CC22705.</p>
					<p style={{marginBottom: '20px'}}>You are receiving this message because this email address was used to register for an SPCA Snip ‘n’ Chip campaign</p>
					<p style={{marginBottom: '20px'}}>SPCA is able to cover the cost of desexing and microchipping your animal(s) thanks to our generous donors, funders and participating vet clinics.</p>
				</div>

				<div style={{width: 'calc(100% - 40px)', background: '#1378C6', color: 'white', padding: 20}}>
					Please click <a href={linkTerms} referrerPolicy={"no-referrer"} target={"_blank"}>here</a> to view the Terms and Conditions for your SPCA Desexing Voucher(s).
				</div>

			</div>
		</div>
	)
}
